import type {
  Response,
  SortBy,
  WidgetFlowT,
  WidgetT,
} from 'lib-shared-legacy-types';

/** Available sort by keys for the widgets API endpoint. */
export enum WigetSortKey {
  CreatedAt = 'created_at',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updated_at',
}

/** Represents the interface for the create widget API endpoint payload. */
export type WidgetCreatePayloadT = Partial<WidgetT>;

/** Represents the interface for the create widget API endpoint response. */
export type WidgetsCreateResponseT = Response<WidgetT>;

/** Represents the interface for the widget API endpoint response. */
export type WidgetsGetItemResponseT = Response<WidgetT>;

/** Represents the interface for the widgets API endpoint response. */
export type WidgetsGetItemsResponseT = Response<{
  /** List of widgets. */
  readonly widgets: WidgetFlowT[];
}>;

/** Represents the interface for the widgets API endpoint query params. */
export type WidgetsQueryParams = {
  /** The limit on number of items in the response. */
  limit?: number;
  /** The string to filter the response by. */
  search?: string;
  /** The sort order in which items will be returned in. */
  sort_by?: SortBy<WigetSortKey>;
};

/** Represents the interface for the update widget API endpoint response. */
export type WidgetsUpdateResponseT = Response<WidgetT>;

/** Represents the interface for the remove widget API endpoint response. */
export type WidgetsRemoveResponseT = Response<WidgetT>;
